module.exports = __webpack_public_path__ + "img/user.a0595fca.png";